let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

/* ==========================================================================
   ZIVANCHE — Celebrity section slider upgrade

   Turns the "Style Like Your Favourite Celebs" grid into a horizontal slider
   on desktop and moves the section's existing arrow buttons on top of the
   images, then shows/hides them from the scroll position.

   Lives in pubsub.js because it is one of the few small scripts theme.liquid
   loads with defer on every page. Paired CSS is at the end of
   assets/component-list-payment.css.

   Progressive enhancement: the CSS only applies once this script marks the
   wrapper with data-zv-slider, so if the script fails the original grid and
   the section's own arrow behaviour are left untouched.
   ========================================================================== */
(function () {
  function initCelebSlider(wrap) {
    if (!wrap || wrap.dataset.zvSlider) return;

    var grid = wrap.querySelector('.celeb-jr-grid');
    if (!grid) return;

    /* Arrows are rendered outside the grid wrapper when the section is set to
       "Next to title", so pull them in here to overlay them on the slider.
       Moving the node keeps the section's own click listeners attached. */
    var section = wrap.closest('.shopify-section') || wrap.parentElement;
    var arrows = section ? section.querySelector('.celeb-jr-arrows') : null;
    if (!arrows) return;

    wrap.appendChild(arrows);
    wrap.dataset.zvSlider = '1';

    var prev = arrows.querySelector('[data-dir="prev"]');
    var next = arrows.querySelector('[data-dir="next"]');

    function sync() {
      var max = grid.scrollWidth - grid.clientWidth;
      var atStart = grid.scrollLeft <= 4;
      var atEnd = max <= 4 || grid.scrollLeft >= max - 4;
      if (prev) prev.classList.toggle('zv-arr-hidden', atStart);
      if (next) next.classList.toggle('zv-arr-hidden', atEnd);
    }

    grid.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* Images load late and change scrollWidth, so re-check a few times. */
    sync();
    setTimeout(sync, 150);
    setTimeout(sync, 600);
    setTimeout(sync, 1500);
  }

  function run() {
    document.querySelectorAll('.celeb-jr-grid-wrap').forEach(initCelebSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Theme editor re-renders sections without a page reload. */
  document.addEventListener('shopify:section:load', run);
})();
